import { render, staticRenderFns } from "./promotion-type.component.vue?vue&type=template&id=373e6952&scoped=true"
import script from "./promotion-type.component.vue?vue&type=script&lang=ts"
export * from "./promotion-type.component.vue?vue&type=script&lang=ts"
import style0 from "./promotion-type.component.vue?vue&type=style&index=0&id=373e6952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373e6952",
  null
  
)

export default component.exports